import { TypedContainer } from "./_Base";
import { csgObjectType } from "../../core/geometry/csg/CsgToObject3D";
export class CsgContainer extends TypedContainer {
  coreContentCloned() {
    if (this._content) {
      return this._content.clone();
    }
  }
  set_content(content) {
    super.set_content(content);
  }
  objectTypes() {
    return this._content.objects().map((o) => csgObjectType(o));
  }
}
